import { Markup } from '@antv/x6';

export const diskMenu = {
    id: "diskMenu",
    width: 120,
    height: 50,
    shape: 'disk-menu',
    data: {
        type: "menu",
        isShow: false
    },
    zIndex: 10
}
export const taskMenu = {
    id: "taskMenu",
    width: 120,
    height: 50,
    shape: 'task-menu',
    data: {
        type: "menu",
        isShow: false
    },
    zIndex: 10
}
export const edgeMenu = {
    id: "edgeMenu",
    width: 120,
    height: 140,
    shape: 'edge-menu',
    data: { disableMove: false, type: "menu" },
    zIndex: 10
}
export const memoMenu = {
    id: "memoMenu",
    width: 120,
    height: 50,
    shape: 'memo-menu',
    data: { type: "menu" },
    zIndex: 20
}
export const commentMenu = {
    id: "commentMenu",
    width: 120,
    height: 50,
    shape: 'comment-menu',
    data: { type: "menu" },
    zIndex: 20
}
export const groupNode = {
    width: 100,
    height: 20,
    zIndex: 10,
    attrs: {
        body: {
            stroke: '#8f8f8f',
            strokeWidth: 1,
            fill: '#47C769',
            rx: 6,
            ry: 6,
        },
        // 指定 text 元素的样式
        label: {
            fill: "#333333", // 文字颜色
            lineHeight: 20,
            backgroundColor: '#fff',
            refX: 10, // x 轴偏移，类似 css 中的 margin-left
            refY: 8,
            xAlign: 'left',
            yAlign: 'top',
            textAnchor: 'left', // 左对齐
            textWrap: {
                width: 100,      // 宽度减少 10px
                height: '60%',   // 高度为参照元素高度的一半
                ellipsis: true,  // 文本超出显示范围时，自动添加省略号
                breakWord: false, // 是否截断单词
            }
        },
    },
}
export const groupInit = {
    width: 120,
    height: 120,
    zIndex: 1,
    attrs: {
        body: {
            stroke: '#8f8f8f',
            strokeWidth: 1,
            fill: '#fff',
            rx: 6,
            ry: 6,
        },
        // 指定 text 元素的样式
        label: {
            fill: "#333333", // 文字颜色
            lineHeight: 20,
            backgroundColor: '#fff',
            refX: 10, // x 轴偏移，类似 css 中的 margin-left
            refY: 8,
            xAlign: 'left',
            yAlign: 'top',
            textAnchor: 'left', // 左对齐
            textWrap: {
                width: 100,      // 宽度减少 10px
                height: '60%',   // 高度为参照元素高度的一半
                ellipsis: true,  // 文本超出显示范围时，自动添加省略号
                breakWord: false, // 是否截断单词
            }
        },
    },
}
export const nodeInit = {

    width: 120,
    height: 120,
    zIndex: 10,
    attrs: {
        body: {
            stroke: "#fff", // 边框颜色
            fill: "#fff", // 填充颜色
            strokeWidth: 1,
            rx: 1, // 圆角矩形
            ry: 1,

        },
        // 指定 text 元素的样式
        label: {
            fill: "#333333", // 文字颜色
            lineHeight: 20,
            backgroundColor: '#fff',
            refX: 10, // x 轴偏移，类似 css 中的 margin-left
            refY: 8,
            xAlign: 'left',
            yAlign: 'top',
            textAnchor: 'left', // 左对齐
            textWrap: {
                width: 100,      // 宽度减少 10px
                height: '60%',   // 高度为参照元素高度的一半
                ellipsis: true,  // 文本超出显示范围时，自动添加省略号
                breakWord: false, // 是否截断单词
            }
        },

    },
}
export const nodeCommentInit = {

    // width: 120,
    // height: 36,
    // // label: "",
    // // shape: "memo-menu",
    // zIndex: 1,
    // attrs: {
    //     body: {
    //         stroke: "#fff", // 边框颜色
    //         fill: "#fff", // 填充颜色
    //         strokeWidth: 1,
    //         rx: 20, // 圆角矩形
    //         ry: 20,

    //     },
    //     // 指定 text 元素的样式
    //     label: {
    //         fill: "#333333", // 文字颜色
    //         lineHeight: 20,
    //         backgroundColor: '#fff',
    //         // refX: 8,
    //         textWrap: {
    //             width: 100,      // 宽度减少 10px
    //             height: '80%',   // 高度为参照元素高度的一半
    //             ellipsis: true,  // 文本超出显示范围时，自动添加省略号
    //             breakWord: false, // 是否截断单词
    //         }
    //     },

    // },
}
export const edgeInit = {

    // defaultLabel: {
    //     markup: Markup.getForeignObjectMarkup(),
    //     attrs: {
    //         fo: {
    //             width: 20,
    //             height: 20,
    //             x: 0,
    //             y: -10,
    //         },
    //     },
    // },
    // label: {
    //     position: 0.5,
    // },

    attrs: {
        line: {
            sourceMarker: null, // 实心箭头
            targetMarker: "block",
            stroke: "#567AEF",
            label: {
                text: "edge label",
            }
        },
        // rect:{
        //     refWidth:90,
        // }
    },
    defaultLabel: {
        markup: Markup.getForeignObjectMarkup(),
        position: {
            distance: 0.5,
        },
        attrs: {
            fo: {
                width: 120,
                height: 90,
                x: -50,
                y: -15,
            },
        },
    },
}
//公共创建便签节点
export const graphAddNodeMemo = (graph: any, i: any) => {
    return graph.addNode({
        shape: "memo-node",
        data: {
            type: 'memos',
            label: (i.content === '') ? '' : i.content,
            //是否展示菜单
            menuShow: false,
            //是否编辑
            isEdit: false,
            //是否选择
            isActive: false,
            //是否切换成更多样式
            isMore: false,
            recoverVisible: false,
            data: { ...i, },
            // tagMetas:i.tagMetas
        },
        id: i.id,
        x: i.x,
        label: (i.content === '') ? '' : i.content,
        y: i.y,
        ...nodeInit,
    })
}
//公共创建注释节点
export const graphAddNodeComment = (graph: any, i: any) => {
    return graph.addNode({
        shape: "comment-node",
        data: {
            type: 'comments',
            label: (i.content === '') ? ' ' : i.content,
            menuShow: false,
            isEdit: false,
            isActive: false,
            data: i,
            recoverVisible: false,
        },
        id: i.id,
        x: i.x,
        y: i.y,
        ...nodeCommentInit,
    });
}
//
export const graphAddEdge = (graph: any, i: any, type?: any) => {
    let obj: any = {
        id: i.id,
        data: {
            type: 'relationBelongTos',
            label: (i.content === '') ? '' : i.content,
            menuShow: false,
            isEdit: false,
            data: i,
            recoverVisible: false,
        },
        zIndex: 1,
        // source: i.superId,
        // target: i.suborId,
        ...edgeInit
    }
    if (type !== 'delayShowRelation') {
        obj.source = i.suborId
        obj.target = i.superId
    }

    return graph.addEdge({ ...obj });
}
//公共群组节点
export const graphAddGroup = (graph: any, i: any, x: any, y: any, height?: any) => {
    return graph.addNode({
        shape: "group",
        data: {
            type: 'group',
            label: (i.subject === '') ? ' ' : i.subject,
            isActive: false,
            data: i,
            parent: true,
            init: false
        },
        id: "group_" + i.id,
        x: x,
        label: (i.subject === '') ? '' : i.subject,
        y: y,
        ...groupInit,
        height: height ? height : 120,
    })
}
//群组子节点
export const graphAddGroupNode = (graph: any, parentId: any, i: any, x?: any, y?: any) => {
    console.log('=graphAddGroupNode', i)
    let _parentId = parentId
    _parentId = _parentId.substring(6, _parentId.length)
    return graph.addNode({
        shape: "group-node",
        data: {
            type: 'group',
            label: (i.content === '') ? ' ' : i.content,
            isActive: false,
            data: i,
            // parent: true,
            init: true
        },
        id: 'groupNode' + _parentId + '_' + i.id,
        x: x,
        label: (i.content === '') ? '' : i.content,
        y: y,
        ...groupNode,
    })
}
